exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-table .success-row {\r\n  background: #03042b;\n}\r\n", ""]);

// exports
